'use client'
import { Configuration } from '@dynamic-labs/sdk-api-core';

/* eslint-disable no-underscore-dangle */
class ApiEndpoint {
}
ApiEndpoint.getBaseUrl = () => {
    if (!ApiEndpoint.__defined__) {
        throw new Error('ApiEndpoint Base URL has not been initialized');
    }
    return ApiEndpoint.__baseUrl__;
};
ApiEndpoint.setBaseUrl = (baseUrlInput) => {
    if (!ApiEndpoint.__defined__) {
        if (!baseUrlInput) {
            /**
             * If the baseUrl is not provided, use the default baseUrl from the sdk-api package
             */
            ApiEndpoint.__baseUrl__ = new Configuration().basePath;
        }
        else {
            ApiEndpoint.__baseUrl__ = baseUrlInput;
        }
        ApiEndpoint.__defined__ = true;
    }
    else if (!baseUrlInput && ApiEndpoint.__defined__) {
        /**
         * If for some reason (usually in local development), the setBaseUrl is called multiple times with undefined
         * And we already have it defined, let's just assume it's a no-op
         */
        return;
    }
    else if (ApiEndpoint.__baseUrl__ !== baseUrlInput) {
        throw new Error(`ApiEndpoint baseUrl is already set to ${ApiEndpoint.__baseUrl__}, cannot change it to ${baseUrlInput}`);
    }
    Object.freeze(ApiEndpoint);
};

export { ApiEndpoint as default };
